import { ModelTranslator } from '@/types/ApiResponseTypes'
import { subscriptionRequestBody } from '@/types/subscription/SubscriptionResponse'
import { isSubscriptionRequest } from '@/types/subscription/SubscriptionType'

class SubscriptionRequestTranslator implements ModelTranslator<subscriptionRequestBody> {
  convertToModel(model: any): subscriptionRequestBody {
    if (isSubscriptionRequest(model)) {
      return {
        page: model.page,
        pageSize: model.pageSize,
      }
    }
    return { page: 0, pageSize: -1 }
  }
}

export default new SubscriptionRequestTranslator()
